<template>
  <d-container fluid class="h-100 flex-fill">
    <loader v-if="load"></loader>
    <d-row class="h-100 flex-fill">
      <!-- Main Sidebar -->
      <main-sidebar :items="sidebarItems" />

      <d-col class="main-content offset-lg-2 offset-md-3 p-0" tag="main" lg="10" md="9" sm="12">
        <!-- Main Navbar -->
        <main-navbar />

        <alert ></alert>
        <!-- Content -->
        <router-view></router-view>

        <!-- Main Footer -->
        <main-footer />
      </d-col>

    </d-row>
  </d-container>
</template>

<script>
import getSidebarItems from '@/data/sidebar-nav-items';

// Main layout components
import MainNavbar from '_common/layout/MainNavbar/MainNavbar.vue';
import MainSidebar from '_common/layout/MainSidebar/MainSidebar.vue';
import MainFooter from '_common/layout/MainFooter/MainFooter.vue';
import Alert from '_shared/Alert.vue';
import Loader from '_shared/Loader.vue';

export default {
  name: 'admin',
  components: {
    Alert,
    Loader,
    MainNavbar,
    MainSidebar,
    MainFooter,
  },
  data() {
    return {
      sidebarItems: getSidebarItems(),
    };
  },
  computed: {
    load() {
      const Loading = this.$store.state.toggle.progress;
      if (Loading) {
        return Loading;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.main-content {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
</style>
